module.exports = __webpack_public_path__ + "img/r-b.357e517a.png";